import { render, staticRenderFns } from "./MPrompt.vue?vue&type=template&id=4742024e"
import script from "./MPrompt.vue?vue&type=script&lang=js"
export * from "./MPrompt.vue?vue&type=script&lang=js"
import style0 from "./MPrompt.vue?vue&type=style&index=0&id=4742024e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports